<template>
  <!-- :class="{ on: popupEventFlag === 'Open' }" -->
  <div class="popup__wrap on" v-if="userSetPopFlag">
    <div class="common__popup user_setting_popup box__shadow__02">
      <div class="popup__top">
        <h4>사용자 세팅</h4>
        <button class="pop__close__btn" @click="closeUserSet"></button>
      </div>
      <ul>
        <li>
          <dl>
            <dt class="f__medium">사용자 ID</dt>
            <dd>
              <input
                type="text"
                readonly
                class="read__only"
                v-model="userInfo.userId"
              />
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">비밀번호</dt>
            <dd>
              <input
                type="password"
                class="custom__input"
                v-model="userInfo.userPwd"
                placeholder="8~20자,영문 대소문자,숫자,특수문자 포함"
                :maxlength="20"
              />
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">비밀번호 확인</dt>
            <dd>
              <input
                type="password"
                class="custom__input"
                v-model="userInfo.userPwdCheck"
                placeholder="8~20자,영문 대소문자,숫자,특수문자 포함"
                :maxlength="20"
              />
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">이름</dt>
            <dd>
              <input
                type="text"
                class="custom__input"
                v-model="userInfo.userName"
              />
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">연락처</dt>
            <dd>
              <input
                type="phone"
                class="custom__input"
                v-model="userInfo.userHp"
              />
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">성별</dt>
            <dd>
              <select name="" id="" v-model="userInfo.userGender">
                <option value="">선택</option>
                <option value="male">남성</option>
                <option value="female">여성</option>
              </select>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">Email</dt>
            <dd>
              <input
                type="email"
                class="custom__input"
                v-model="userInfo.userEmail"
              />
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">기관</dt>
            <dd>
              <select
                name=""
                id=""
                ref="orgnSelector"
                v-model="userInfo.orgnId"
              >
                <option value="">선택</option>
                <option
                  v-for="orgn in orgnList"
                  :key="orgn.index"
                  :value="orgn.orgnId"
                >
                  {{ orgn.orgnNm }}
                </option>
              </select>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">진료과/부서</dt>
            <dd>
              <select
                name=""
                id=""
                ref="orgnSelector"
                v-model="userInfo.deptId"
                disabled
              >
                <option value="">선택</option>
                <option
                  v-for="dept in deptList"
                  :key="dept.index"
                  :value="dept.codeId"
                >
                  {{ dept.codeName }}
                </option>
              </select>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">권한</dt>
            <dd>
              <select name="" id="" v-model="userInfo.roleId" disabled>
                <option value="">선택</option>
                <option
                  v-for="role in roleList"
                  :key="role.index"
                  :value="role.codeId"
                >
                  {{ role.codeName }}
                </option>
              </select>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt class="f__medium">사용여부</dt>
            <dd>
              <input type="text" readonly class="read__only" value="사용" />
            </dd>
          </dl>
        </li>
      </ul>
      <div class="button__wrap">
        <button class="custom__btn" @click="updateCurrentUser">
          <p class="btn-icon save-icon">저장</p>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { updateUser } from "@/api/user";
import { getCommonCodeList } from "@/api/code";
import { getOrgnList } from "@/api/orgn";
import { checkPassword } from "@/utill/validator";

export default {
  data() {
    return {
      userInfo: {
        userId: "",
        userPwd: "",
        userName: "",
        userHp: "",
        userGender: "",
        userEmail: "",
        deptId: "",
        deptName: "",
        roleId: "",
        roleName: "",
        orgnId: "",
        useYn: "Y",
      },
      orgnList: [],
      deptList: [],
      roleList: [],
    };
  },
  created() {
    this.getUserInfo();
    this.getOrgns();
    this.getDepts();
    this.getRoles();
  },
  props: {
    userSetPopFlag: Boolean,
  },
  methods: {
    getOrgns() {
      getOrgnList().then((response) => {
        this.orgnList = response.data.response.data;
      });
    },
    getDepts() {
      let searchQuery = "mainCommCode=DEPT&useYn=Y";
      getCommonCodeList(searchQuery).then((response) => {
        this.deptList = response.data.response.codeList;
      });
    },
    getRoles() {
      let searchQuery = "mainCommCode=ROLE&useYn=Y";
      getCommonCodeList(searchQuery).then((response) => {
        this.roleList = response.data.response.codeList;
      });
    },
    closeUserSet() {
      this.getUserInfo();
      this.userInfo.userPwd = "";
      this.userInfo.userPwdCheck = "";
      this.$emit("closeUserSet", false);
    },
    async getUserInfo() {
      try {
        await this.$store.dispatch("getUserInfo");
        this.userInfo.userId = this.$store.state.auth.userInfo.userId;
        this.userInfo.userName = this.$store.state.auth.userInfo.name;
        this.userInfo.userHp = this.$store.state.auth.userInfo.contact;
        this.userInfo.userGender = this.$store.state.auth.userInfo.sex;
        this.userInfo.userEmail = this.$store.state.auth.userInfo.email;
        this.userInfo.deptId = this.$store.state.auth.userInfo.deptId;
        this.userInfo.deptName = this.$store.state.auth.userInfo.deptName;
        this.userInfo.roleId = this.$store.state.auth.userInfo.roleId;
        this.userInfo.roleName = this.$store.state.auth.userInfo.roleName;
        this.userInfo.orgnId = this.$store.state.auth.userInfo.orgnId;

        if (this.$env == "development") console.log(this.userInfo);
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
    updateCurrentUser() {
      if (!this.validateUser()) return;
      updateUser(this.userInfo)
        .then((response) => {
          if (response.data.status === "OK") {
            this.$toast.success("사용자 수정이 완료되었습니다");
            this.closeUserSet();
          }
        })
        .catch((error) => this.$toast.error(error.message));
    },
    validateUser() {
      if (!checkPassword(this.userInfo.userPwd)) {
        this.$toast.error(
          "사용자 비밀번호는 8~20자 내 영문 대소문자, 숫자, 특수문자를 반드시 포함해야 합니다."
        );
        return false;
      }
      if (
        this.userInfo.userPwdCheck === "" ||
        this.userInfo.userPwdCheck === null
      ) {
        this.$toast.error("사용자 비밀번호를 다시 입력하세요.");
        return false;
      }
      if (this.userInfo.userPwd !== this.userInfo.userPwdCheck) {
        this.$toast.error("비밀번호를 일치하지 않습니다.");
        return false;
      }
      if (this.userInfo.userName === "" || this.userInfo.userName === null) {
        this.$toast.error("사용자 이름을 입력하세요.");
        return false;
      }
      if (this.userInfo.userHp === "" || this.userInfo.userHp === null) {
        this.$toast.error("연락처를 입력하세요.");
        return false;
      }
      if (
        this.userInfo.userGender === "" ||
        this.userInfo.userGender === null
      ) {
        this.$toast.error("성별을 입력하세요.");
        return false;
      }
      if (this.userInfo.userEmail === "" || this.userInfo.userEmail === null) {
        this.$toast.error("이메일을 입력하세요.");
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.custom__btn {
  margin-top: 20px;
}
</style>
